export default __webpack_public_path__ + "static/logo-7c2eb577d69406b263274ee7740cef50.svg";